import { render, staticRenderFns } from "./EditChat.vue?vue&type=template&id=c16fb48c&scoped=true&"
import script from "./EditChat.vue?vue&type=script&lang=js&"
export * from "./EditChat.vue?vue&type=script&lang=js&"
import style0 from "./EditChat.vue?vue&type=style&index=0&id=c16fb48c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16fb48c",
  null
  
)

export default component.exports